import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';
import { SpecialtiesService } from 'src/app/cms/specialties/specialties.service';
import { InsurancesService } from 'src/app/cms/insurances/insurances.service';
import { GroupsService } from '../groups/groups.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  providers: [FilteredListConfig]
})
export class ContactsComponent implements OnInit {
  contacts$: Observable<any>
  private contacts: any[]
  contactsForm: FormGroup
  groups$: Observable<any>
  selectedRecordType: string
  coordinates: Coordinates
  showIndicator: boolean
  params: any
  showAdvanced = false
  specialties$: Observable<any[]>
  insurances$: Observable<any[]>
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private ss: SpecialtiesService,
    private is: InsurancesService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
      this.createForm()
    })
    this.route.data.subscribe((data: {contacts: any}) => {
      this.showIndicator = false
      this.contacts$ = data.contacts
      this.contacts = data.contacts.data
      this.config.listItems = this.contacts.map(contact => {
        let badges: Badge[] = [
          {
            text: contact.id,
            className: 'badge-info'
          }
        ]
        return {
          _id: contact.id,
          title: contact.title || contact.zip,
          description: `${contact.subtitle ? contact.subtitle+'<br>' : ''}${contact.distance ? contact.distance + ' miles' : ''}`,
          badge: badges
        }
      });
      this.config.count = data.contacts.count
      this.config.page = data.contacts.page
      this.config.limit = data.contacts.limit
      this.config.emitChanges()
    })
    this.specialties$ = this.ss.getSpecialtiesPicker()
    this.insurances$ = this.is.getinsurancesPicker()
    this.config.title = 'Contacts'
    this.config.listItemClicked = this.contactSelected
  }

  onChanges(): void {
    this.useLocation.valueChanges.subscribe(useLocation => {
      if (useLocation) {
        this.showIndicator = true
        this.addGeolocationParamsAndNavigate(this.params)
      } else {
        delete this.params.geolocation
        delete this.params.lat
        delete this.params.lon
        this.router.navigate([this.params], {relativeTo: this.route})
      }
    })
    this.insurance.valueChanges.subscribe(val => {
      this.updateParam('insurance', val)
    })
    this.specialty.valueChanges.subscribe(val => {
      this.updateParam('specialty', val)
    })
  }

  updateParam(param: string, val: string) {
    if (!val) delete this.params[param]
    else this.params[param] = val
    this.router.navigate([this.params], {relativeTo: this.route})
  }

  addGeolocationParamsAndNavigate(params: any) {
    if (!navigator.geolocation){
      return alert('Location not available');
    }
    navigator.geolocation.getCurrentPosition((position) => {
      params.lat = position.coords.latitude
      params.lon = position.coords.longitude
      params.geolocation = true
      this.router.navigate([params], {relativeTo: this.route})
    }) 
  }

  createForm = () => {
    this.contactsForm = this.fb.group({
      useLocation: [this.params.geolocation],
      specialty: [this.params.specialty || ''],
      insurance: [this.params.insurance || ''],
    })
    this.onChanges()
  }

  contactSelected = (id: string) => {
    this.router.navigate([id], { relativeTo: this.route })
  }

  get useLocation() { return this.contactsForm.get('useLocation') }
  get specialty() { return this.contactsForm.get('specialty') }
  get insurance() { return this.contactsForm.get('insurance') }
}
